import React from 'react';
import { Stack, Typography } from '@mui/material';

import { ImageAvatar } from 'components/Avatar';
import { PaperCard } from 'components/Card';
import DelegonSmallLogo from 'assets/Delegon_Small_Logo.png';

const TYPE_LABELS = {
  fa: 'Framework agreement',
  dps: 'DPS',
  direct: 'Direct',
};

export const InstrumentCard = ({ instrumentType, name, refNumber, description, logoUrl, logoName, onClick }) => (
  <PaperCard
    onClick={onClick}
    sx={{
      flex: 1,
      minWidth: 0,
      boxShadow: 0,
      borderRadius: 1,
      p: 2,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      borderColor: 'border.main',
      borderWidth: 1,
      borderStyle: 'solid',
    }}
  >
    <Stack flexDirection="column" gap={2} justifyContent="space-between" sx={{ height: 1, minWidth: 0 }}>
      <Stack gap={1}>
        <Typography
          variant="h2"
          fontSize="1.125rem"
          fontWeight={700}
          lineHeight="normal"
          sx={{
            display: '-webkit-box',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            minHeight: '44px',
            wordBreak: 'break-word',
          }}
        >
          {name}
        </Typography>
        {refNumber && (
          <Typography variant="caption" fontWeight={600} color="text.secondary">
            REF {refNumber}
          </Typography>
        )}
        <Typography
          variant="body2"
          fontSize="0.75rem"
          fontWeight={300}
          color="text.secondary"
          sx={{
            display: '-webkit-box',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            minHeight: '54px',
            wordBreak: 'break-word',
          }}
        >
          {description}
        </Typography>
      </Stack>

      <Stack flexDirection="row" gap={1.5} sx={{ alignItems: 'center' }}>
        <ImageAvatar
          img={logoUrl || DelegonSmallLogo}
          name={logoName || 'Delegon'}
          sx={{
            backgroundColor: '#fff',
            width: 36,
            height: 36,
            img: { width: 36, height: 36, overflow: 'hidden' },
          }}
        />
        <Typography variant="body1" fontSize="1.125rem" fontWeight={600} color="text.secondary">
          {TYPE_LABELS[instrumentType]}
        </Typography>
      </Stack>
    </Stack>
  </PaperCard>
);
